import { render, staticRenderFns } from "./configSelectGroupObject.vue?vue&type=template&id=08b9fb3c&"
import script from "./configSelectGroupObject.vue?vue&type=script&lang=js&"
export * from "./configSelectGroupObject.vue?vue&type=script&lang=js&"
import style0 from "./configSelectGroupObject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports